define('collections/product_categories',['require','collections/base','models/product_category'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/product_category");

    return BaseCollection.extend({
        model: Model,
        url: 'product-categories.json'
    });
});

